import { jsx as r } from "react/jsx-runtime";
import { Box as s } from "@chakra-ui/react";
import { useDropdownStyle as t } from "../Dropdown.context.es.js";
const p = () => {
  const o = t();
  return /* @__PURE__ */ r(s, { as: "hr", __css: o.divider });
};
export {
  p as DropdownDivider
};
//# sourceMappingURL=DropdownDivider.es.js.map
